import ContactsForCall from "./components/ContactsForCall";

const ContactsContainer = () => {
  return (
    // <div className="w-full px-4 py-9  bg-white md:max-w-[1000px] min-h-[calc(100vh_-_320px)]">
    <div className="w-full px-4 pt-9  bg-white md:max-w-[1000px] md:px-0">
      <h1 className="pb-5 text-2xl font-bold">Контакти</h1>
      <p className="text-base">
        Радіо «Сільпо» звучить для вас. І ми хочемо, щоб вам подобалося те, що
        ви чуєте.
        <br />
        Для релізів, пропозицій та співпраці пишіть на нашу пошту.
      </p>
      <div className="pt-5 w-full md:flex md:flex-wrap md:pt-5">
        <div className="w-full">
          <h5 className="text-base font-semibold">Контакти для звʼязку</h5>
          <ContactsForCall />
        </div>
      </div>
    </div>
  );
};

export default ContactsContainer;
